import { eMode } from "../../../content/enum";
import { ITsLePhiBuocNhayActionTypes } from "../../action-types/category/ITsLePhiBuocNhayActions";
import { ITsLePhiBuocNhayReducer } from "../../reducer-model/category/ITsLePhiBuocNhayReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: ITsLePhiBuocNhayReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dot_tuyen_sinh: 0,
  items: [],
  heNganhsTheoDot: [],
  mode: eMode.xem,
};

export const lePhiBuocNhayReducer = (
  state: ITsLePhiBuocNhayReducer = iniState,
  action: ITsLePhiBuocNhayActionTypes
): ITsLePhiBuocNhayReducer => {
  switch (action.type) {
    case "LE_PHI_BUOC_NHAY_CHANGE_DOT":
      return {
        ...state,
        dot_tuyen_sinh: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LE_PHI_BUOC_NHAY_CHANGE_MODE":
      return { ...state, mode: action.payload };
    case "LE_PHI_BUOC_NHAY_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "LE_PHI_BUOC_NHAY_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        items: action.payload,
      };
    case "LE_PHI_BUOC_NHAY_LOAD_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "LE_PHI_BUOC_NHAY_LOAD_HE_NGANH_SUCCESS":
      return { ...state, heNganhsTheoDot: action.payload };
    case "LE_PHI_BUOC_NHAY_LOAD_HE_NGANH_ERROR":
      return { ...state, heNganhsTheoDot: [] };
    case "LE_PHI_BUOC_NHAY_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "LE_PHI_BUOC_NHAY_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        // Thay toàn bộ mốc của phạm vi (hệ, ngành) vừa lưu bằng dữ liệu trả về.
        items: [
          ...state.items.filter(
            (x) =>
              !(
                x.id_he === action.payload.id_he &&
                x.id_nganh === action.payload.id_nganh
              )
          ),
          ...action.payload.items,
        ],
      };
    case "LE_PHI_BUOC_NHAY_SAVE_ERROR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
